import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "each-side-show-box common-flex-direction-center"
};

const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "common-title wow slideInUp"
}, "迪想校园系统页面展示", -1);

const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "common-des wow slideInUp"
}, "缜密逻辑体系，打造领先行业的标杆产品", -1);

const _hoisted_4 = {
  class: "each-side-show-box-tab-box"
};
const _hoisted_5 = ["onMouseover"];
const _hoisted_6 = {
  class: "content"
};
const _hoisted_7 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _hoisted_3, _createElementVNode("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.TabList, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: _normalizeClass(["tab-item", $data.activeIndex == index ? 'active' : '']),
      key: index,
      onMouseover: $event => $options.mouseoverTab(index)
    }, _toDisplayString(item), 43, _hoisted_5);
  }), 128))]), _createElementVNode("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.imageList, (image, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "content-item",
      key: index
    }, [$data.activeIndex == index ? (_openBlock(), _createElementBlock("img", {
      key: 0,
      class: "item-image wow jackInTheBox",
      src: image
    }, null, 8, _hoisted_7)) : _createCommentVNode("", true)]);
  }), 128))])]);
}